/* eslint-env browser */
import { useEffect } from 'react';

/**
 * Custom boot animation for Avatar Sharing Christ
 * Uses purple colors to match the app's branding
 * This component is rendered by index.js before App.js loads TW or anything else
 */

const stylesheet = `
	@keyframes asc-boot-anim-spin {
		to {
			transform: rotate(360deg);
		}
	}

	.asc-boot-anim-wrapper {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: linear-gradient(to bottom right, #faf5ff, #f3e8ff);
	}

	@media (prefers-color-scheme: dark) {
		.asc-boot-anim-wrapper {
			background: linear-gradient(to bottom right, #1e1b4b, #312e81);
		}
	}

	.asc-boot-anim-spin-position {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.asc-boot-anim-spinner {
		animation: asc-boot-anim-spin 1s linear infinite;
		width: 8rem;
		height: 8rem;
		color: rgba(168, 85, 247, 0.5); /* purple-500 with opacity */
	}

	@media (prefers-color-scheme: dark) {
		.asc-boot-anim-spinner {
			color: rgba(192, 132, 252, 0.5); /* purple-400 with opacity */
		}
	}
`;

// I know it's generally bad form in react to modify the DOM,
// but I'm doing this here to prevent FOC on first boot.
// We still remove this from the DOM as soon as we unmount, so pretty safe.
const style = document.createElement('style');
style.id = 'boot-anim-asc';
style.innerHTML = stylesheet;
const insertLocation = document.querySelector('script');
insertLocation.parentNode.insertBefore(style, insertLocation);

export function BootAnim() {
	useEffect(() => {
		return () => {
			if (insertLocation && insertLocation.parentNode) {
				try {
					insertLocation.parentNode.removeChild(style);
				} catch (error) {
					// eslint-disable-next-line no-console
					console.warn(`[ASC BootAnim] Error removing style element:`, error);
				}
			}
		};
	});

	return (
		<div className="asc-boot-anim-wrapper">
			<div className="asc-boot-anim-spin-position">
				<svg
					className="asc-boot-anim-spinner"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
				>
					<circle
						className="opacity-25"
						cx="12"
						cy="12"
						r="10"
						stroke="currentColor"
						strokeWidth="4"
					></circle>
					<path
						fill="currentColor"
						d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
					></path>
				</svg>
			</div>
		</div>
	);
}
